import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import { setTitle } from "../../actions"

import Swiper from 'react-id-swiper';
import  './styles/onboardStyles.scss';
import logo from './images/logo.svg';

@connect((store) => {
	return { User: store.User.User, app: store.app, practices: store.practices }
})

class OwnerOnboarding extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			firstTime: false
		}
	}

	componentDidMount() {
		this.checkFirstTime();
		this.toggleClassOnboarding();
	}

	checkFirstTime() {

		var url_string = window.location.href;
		var url = new URL(url_string);

		this.setState({
			firstTime:(url.searchParams.has('nav')) ? false : true
		})
	}

	componentWillUnmount(){
		this.toggleClassOnboarding();
	}

	toggleClassOnboarding(){
		document.body.classList.toggle('onboarding');
	}

	toggleRedirect(page) {

		var newUrl = '/onboarding/'+page;
		var url_string = window.location.href;
		var url = new URL(url_string);

		if(url.searchParams.has('redirect')) {
			newUrl = (url.searchParams.has('redirect')) ? '/onboarding/'+page+'?redirect='+url.searchParams.get('redirect'): '/'+page;
		}

		var nav = !this.state.firstTime ? '?nav' : '';

		return newUrl+nav
	}

	render() {
		return (
			<main id="onboarding">
                <div className="onboardContainer">
                    <div className="logoAndHeadText">
                        <img src={logo} alt="Logo"/>
                        <p>Please select one of the options below.</p>
                    </div>
                    <div className="selections">
                        <a href={this.toggleRedirect('owner')}>{this.state.firstTime ? 'Joining as ' : ''}Owner</a>
                        <a href={this.toggleRedirect('therapist')}>{this.state.firstTime ? 'Joining as ' : ''}Therapist</a>
                        <a href={this.toggleRedirect('parent')}>{this.state.firstTime ? 'Joining as ' : ''}Patient</a>
                    </div>
                </div>
            </main>
		);
	}
}

export default withRouter(OwnerOnboarding)


// WEBPACK FOOTER //
// ./src/components/onboarding/Onboarding.jsx